import React, { useState } from "react";
import "./CareerForm.css";

const CareerForm = ({ designation, closeForm }) => {

  const [formData, setFormData] = useState({
    name: "",
    age: "",
    qualification: "",
    designation: designation,
    email: "",
    mobile: "",
    address: "",
    experience: "",
    cv: null
  });

  const [fileName, setFileName] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {

    const { name, value, files } = e.target;

    if (files) {

      setFormData({
        ...formData,
        [name]: files[0]
      });

      setFileName(files[0].name);

    } else {

      setFormData({
        ...formData,
        [name]: value
      });

    }

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {

      const response = await fetch(
        "https://fidinventures.in/api/career.php",
        {
          method: "POST",
          body: data
        }
      );

      const result = await response.text();

      console.log(result);

      setShowSuccess(true);

      setTimeout(() => {

        setShowSuccess(false);

        closeForm();

      }, 2500);

    }
    catch (error) {

      console.error("ERROR:", error);

      alert("Something went wrong");

    }

    setLoading(false);

  };

  return (

    <>

      {
        showSuccess &&
        <div className="success-toast">
          Application Submitted Successfully ✅
        </div>
      }

      <div className="career-form-overlay">

        <div className="career-form-box">

          <button
            className="close-btn"
            onClick={closeForm}
          >
            ×
          </button>

          <div className="form-top">

            <h2>Career Opportunity</h2>

            <p>
              Join our growing team and build your future with us.
            </p>

          </div>

          <form onSubmit={handleSubmit}>

            <div className="form-grid">

              <input
                type="text"
                name="name"
                placeholder="Full Name"
                onChange={handleChange}
                required
              />

              <input
                type="number"
                name="age"
                placeholder="Age"
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="qualification"
                placeholder="Qualification"
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="designation"
                value={designation}
                readOnly
              />

            </div>

            <textarea
              name="address"
              placeholder="Address"
              rows="3"
              onChange={handleChange}
              required
            ></textarea>

            <textarea
              name="experience"
              placeholder="Work Experience"
              rows="4"
              onChange={handleChange}
            ></textarea>

            <div className="file-upload-box">

              <label htmlFor="cvUpload" className="upload-btn">
                Attach Resume
              </label>

              <input
                type="file"
                id="cvUpload"
                name="cv"
                onChange={handleChange}
                hidden
              />

              {
                fileName &&
                <p className="file-name">
                  📄 {fileName}
                </p>
              }

            </div>

            <button
              type="submit"
              className="submit-btn"
            >
              {
                loading
                  ? "Submitting..."
                  : "Apply Now"
              }
            </button>

          </form>

        </div>

      </div>

    </>

  );

};

export default CareerForm;